<template>
  <div :class="radioIsActive()">
    <input
      class="radio-input"
      type="radio"
      :checked="isActive"
      @click="onClick"
      :disabled="disabled"
      :id="id"
    />
    <div v-if="label" class="radio-label">
      <label :for="id">{{ label }}</label>
    </div>
  </div>
</template>
<script>
export default {
  name: "radio-select",
  props: {
    id: String,
    onClick: Function,
    isActive: Boolean,
    label: String,
    disabled: Boolean,
  },
  methods: {
    radioIsActive() {
      let className = "radio";

      if (this.isActive) {
        className += " || " + "is-active";
      }
      if (this.disabled) {
        className += " || " + "disabled";
      }

      return className;
    },
  },
};
</script>
